<script setup lang="ts">
  import type { ToastItem } from '@liebherr/patternlib/loader';
  import { onBeforeMount, provide, ref } from 'vue';
  import { isLoading } from './config/axios.global';

  provide('isLoading', isLoading);

  const toast = ref<HTMLPatternlibToastElement>();
  const displayBreakpoint = ref<string>();

  const createToast = async (
    toastMessage: string = '',
    customTextInput: string = '',
    toastType: ToastItem['type'] = 'warning'
  ) => {
    await toast.value?.createToastItem({
      message: toastMessage,
      customContent: customTextInput,
      showIcon: true,
      type: toastType,
      showUndo: false,
      autoHide: true,
      delay: 6000
    });
  };

  const getDisplayBreakpoint = () => {
    return document.documentElement.getAttribute('breakpoint') ?? 'isDesktop';
  };

  provide('createToast', createToast);

  const displayBreakpointObserver = new ResizeObserver(() => {
    if (!document.documentElement.getAttribute('breakpoint')) {
      displayBreakpoint.value = 'isDesktop';
      return;
    }

    displayBreakpoint.value = getDisplayBreakpoint();
  });
  displayBreakpointObserver.observe(document.body);

  onBeforeMount(async () => {
    document.documentElement.setAttribute('data-context', 'portal');
    document.documentElement.setAttribute('data-theme', 'hau');
  });

  displayBreakpoint.value = getDisplayBreakpoint();
  provide('displayBreakpoint', displayBreakpoint);

  // resize observer for setting displayBreakpoint
</script>

<template>
  <div :class="$gStyle('p-[32px]')">
    <router-view></router-view>

    <!-- Toast -->
    <patternlib-toast ref="toast" position="bottom-right"></patternlib-toast>
  </div>
</template>

<style scoped>
  .w-700 {
    max-width: 700px;
  }
</style>
